import { useEffect, useState } from 'react';
import { BaseInput } from './';

type NumericType = 'float' | 'integer' | 'economicFloat';

interface ControlledNumericInputProps {
  val: string;
  inputLabel: string;
  validationError: boolean;
  maxNumber: number;
  type: NumericType;
  inputType?: string;
  onError(error: boolean): void;
  onTextChange(value: string): void;
  disabled?: boolean;
  maxLength?: number;
  inputPlaceholder?: string;
  extraClass?: string;
  extraClassTitle?: string;
  extraClassContainer?: string;
  dataCy?: string;
  handleKeypress?(e: any): void;
}

const ControlledNumericInput: React.FC<ControlledNumericInputProps> = ({
  val,
  inputLabel,
  validationError,
  maxNumber,
  type,
  onError,
  onTextChange,
  inputType,
  disabled,
  inputPlaceholder,
  maxLength,
  extraClass,
  extraClassTitle,
  extraClassContainer,
  dataCy,
  handleKeypress,
}) => {
  const decimal_precision = 2;
  const [inError, setInError] = useState(false);
  useEffect(() => {
    setInError(validationError);
  }, [validationError]);
  const validateValueInput = (value: string): boolean => {
    try {
      if (value === '') {
        onError(false);
        return true;
      }
      let numRegex: RegExp;
      if (type === 'float') {
        numRegex = /^-?\d+(\.\d{0,2})?$/;
      } else if (type === 'economicFloat') {
        numRegex = new RegExp(`^-?\\d+(\\.\\d{0,${decimal_precision}})?$`);
      } else {
        numRegex = /^-?\d+$/;
      }
      if (!numRegex.test(value)) {
        onError(true);
        return false;
      }

      const num = Number(value);
      if (!Number.isNaN(num) && num >= 0 && num <= maxNumber) {
        onError(false);
        return true;
      }
      onError(true);
      return false;
    } catch (e: any) {
      onError(true);
      return false;
    }
  };
  return (
    <BaseInput
      val={val}
      inputLabel={inputLabel}
      inputPlaceholder={inputPlaceholder}
      inError={inError}
      maxLength={maxLength}
      disabled={disabled}
      type={inputType}
      onTextChange={(newVal: string) => {
        if (validateValueInput(newVal)) {
          onTextChange(newVal);
          onError(false);
        } else {
          onError(true);
        }
      }}
      handleKeypress={handleKeypress}
      dataCy={dataCy}
      extraClassContainer={extraClassContainer}
      extraClassTitle={extraClassTitle}
      extraClass={extraClass}
    />
  );
};

export { ControlledNumericInput };
